import { useState, useEffect } from "react";
import { Col, Form, Modal, Row, Alert } from "react-bootstrap";
import { AddNewSfa, UpdateSfa } from "../../Services/sfa-service";
import SuccessAlertModal from "../Modals/successAlertModal";
import ConfirmAlertModal from "../Modals/confirmAlertModal";
import { useNavigate } from "react-router-dom";
import { isAlphanumericWithDot, isAlphanumericWithSpaceandDash } from "../../functions/validations";
import { showSuccess, showWarning } from "../utility/ui/notifications/Toaster";
import ButtonModal from "../Modals/buttonModal";
import PropTypes from 'prop-types';

const AddEditSfaMaster = (props) => {
  AddEditSfaMaster.propTypes = {
    allRecs: PropTypes.array,
    rowdata: PropTypes.object,
    action: PropTypes.string,
    onHide: PropTypes.func,
    setReload: PropTypes.func,
    reload: PropTypes.bool
  };
  if (props.rowdata.wld_status === "Active") {
    props.rowdata.wld_status = true;
  } else if (props.rowdata.wld_status === "Inactive") {
    props.rowdata.wld_status = false;
  }

  let action = props.action;
  let formName = "SFA";

  const [showSuccessModel, setShowSuccessModel] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showConfirmModel, setshowConfirmModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [toggleClass, setToggleClass] = useState(
    (action === "Edit" ? props.rowdata.wld_status : true) ? "activeToggleLabel" : "inactiveToggleLabel"
  );
  const history = useNavigate();
  let username = sessionStorage.getItem("UserName");


  const [SfaObj, setSfaObj] = useState(
    action === "Edit"
      ? props.rowdata
      : {
        wld_status: true,
        wld_code: "",
        wld_description: "",
        SK: "",
        PK: "Sfa",
        wld_createdby: "",
        wld_createdon: "",
        wld_updatedby: "",
        wld_updatedon: "",
      }
  );
  const [error, setError] = useState({
    SK: {},
    PK: {},
    wld_status: {},
    wld_code: {},
    wld_description: {},
    wld_createdby: {},
    wld_createdon: {},
    wld_updatedby: {},
    wld_updatedon: {},
  });
  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setSfa",
    });
  };

  const handleCloseSuccess = () => {
    setShowSuccessModel(false);
    props.onHide();
    props.setReload(!props.reload);
  };

  const handleCloseConf = () => {
    setshowConfirmModel(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSfaObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((prevState) => ({
      ...prevState,
    }));
  };

  const handleSwitchChange = (e) => {
    if (e.target.checked) {
      setToggleClass("activeToggleLabel")
    } else {
      setToggleClass("inactiveToggleLabel")
    }

    setSfaObj((prevState) => ({
      ...prevState,
      wld_status: e.target.checked,
    }));
  };

  const resetForm = () => {
    if (action === "Add") {
      setSfaObj((prevState) => ({
        ...prevState,
        wld_status: true,
        wld_code: "",
        wld_description: "",
        SK: "",
        wld_createdby: "",
        wld_createdon: "",
      }));
      setToggleClass("activeToggleLabel");
    } else if (action === "Edit") {
      setSfaObj((prevState) => ({
        ...prevState,
        PK: props.rowdata.PK,
        SK: props.rowdata.SK,
        wld_status: props.rowdata.wld_status,
        wld_code: props.rowdata.wld_code,
        wld_description: props.rowdata.wld_description,
        wld_createdby: props.rowdata.wld_createdby,
        wld_createdon: props.rowdata.wld_createdon,
      }));
      setToggleClass(props.rowdata.wld_status ? "activeToggleLabel" : "inactiveToggleLabel");
    }
    setError((prevState) => ({
      ...prevState,
      wld_code: {},
      wld_description: {},
      SK: {},
    }));
  };

  const validateSfa = (action) => {
    let result = false;
    let isError = false;
    if (SfaObj.wld_code.trim() === "") {
      SfaObj.wld_code = "";
      isError = true;
      error.wld_code = {
        status: true,
        message: "Sfa Number is required.",
      };
    }

    if (SfaObj.wld_description.trim() === "") {
      SfaObj.wld_description = "";
      isError = true;
      error.wld_description = {
        status: true,
        message: "Sfa Description is required.",
      };
    }

    if (SfaObj.wld_status === "") {
      isError = true;
      error.wld_status = {
        status: true,
        message: "Status is required.",
      };
    }

    if (action === "Add") {
      result = props.allRecs?.find(
        (item) =>
          item.PK.toLowerCase() === SfaObj.PK.toLowerCase() &&
          item.SK.toLowerCase() === SfaObj.wld_code.toLowerCase()
      );
    }

    if (result) {
      setAlertMessage("Sfa Combination Already Exists!");
      isError = true;
    }
    setError((prevState) => ({
      ...prevState,
      ...error,
    }));
    if (
      error.SK.status ||
      error.wld_code.status ||
      error.wld_description.status
    ) {
      isError = true;
    }
    return isError;
  };
  const handleAdd = (e) => {
    let result;
    if (SfaObj.wld_status === true) {
      SfaObj.wld_status = "Active";
    } else {
      SfaObj.wld_status = "Inactive";
    }
    if (action === "Add") {
      SfaObj.SK = SfaObj.wld_code;
      SfaObj.wld_createdby = username;

      result = AddNewSfa(SfaObj);
    } else {
      SfaObj.wld_updatedby = SfaObj.wld_createdby;

      result = UpdateSfa(SfaObj);
    }
    result
      .then((resp) => {
        if (action === "Edit") {
          showSuccess(`Selected SFA has been Updated successfully`);
        }
        if (resp.message === "Duplicate") {
          showWarning(resp.message);
        } else if (action === "Add") {
          showSuccess(`Selected SFA has been Added successfully`);
        }
        props.setReload(!props.reload);
        setShowForm(false);
        props.onHide();
      })
      .catch((error) => {
        console.log("Failed");
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateSfa(action)) {
      setshowConfirmModel(true);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setAlertMessage("");
    }, 10000);
    return () => clearTimeout(timer);
  }, [alertMessage]);


  return (
    <>
      <SuccessAlertModal
        clickFunction={modalOnClick}
        msg={`Great! You've ${action}ed Sfa successfully.`}
        show={showSuccessModel}
        handleClose={handleCloseSuccess}
      />
      <ConfirmAlertModal
        action={action}
        handleYes={handleAdd}
        formName={formName}
        show={showConfirmModel}
        handleClose={handleCloseConf}
      />
      <Modal
        {...props}
        size="lg"
        centered
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} SFA </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} autoComplete="off">
          <Modal.Body>
            <div className="px-2">
              <Row className="gx-3">
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        type="text"
                        id="wld_code"
                        name="wld_code"
                        placeholder=" "
                        disabled={action === "Edit"}
                        maxLength="5"
                        className={
                          error.wld_code.status
                            ? " g-input placeHolderInput inputText text-field-with-error allow"
                            : "g-input placeHolderInput inputText allow"
                        }
                        value={SfaObj.wld_code}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericWithDot(e.target.value);
                          setError((prevState) => ({
                            ...prevState,
                            wld_code: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_code">
                        SFA Number{" "}
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_code.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "20px" }}>
                          {error.wld_code.message}
                        </span>{" "}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <div className="g-input">
                      <input
                        id="wld_description"
                        name="wld_description"
                        type="text"
                        maxLength="50"
                        className={`asterisk ${error.wld_description.status
                          ? "placeHolderInput inputText text-field-with-error allow"
                          : "placeHolderInput inputText allow"
                          }`}
                        placeholder=" "
                        value={SfaObj.wld_description}
                        onChange={handleChange}
                        onInput={(e) => {
                          let error = isAlphanumericWithSpaceandDash(
                            e.target.value
                          );
                          setError((prevState) => ({
                            ...prevState,
                            wld_description: error,
                          }));
                        }}
                      />
                      <Form.Label className="required-field" htmlFor="wld_description">
                        SFA Description
                      </Form.Label>
                    </div>{" "}
                    &nbsp;&nbsp;
                    {error.wld_description.status && (
                      <Form.Text className="text-danger">
                        <span style={{ position: "relative", bottom: "10px" }}>
                          {error.wld_description.message}
                        </span>{" "}
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4} md={12}>
                  <Form.Group className="form-switch-input mt-1">
                    <Form.Label className="fieldLabel mb-0">Status</Form.Label>
                    <Form.Switch
                      className={"semiBoldToggleButton " + toggleClass}
                      name="wld_status"
                      checked={SfaObj.wld_status}
                      onChange={handleSwitchChange}
                    />
                    <span className={"fieldLabel " + toggleClass}>
                      {SfaObj.wld_status ? "Active" : "Inactive"}
                    </span>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            {alertMessage && (
              <Alert className="alertBox" variant="warning">
                {alertMessage}
              </Alert>
            )}
          </Modal.Body>

          <Row>
            <ButtonModal action={action} resetForm={resetForm}></ButtonModal>
          </Row>

          <Row>
            <br></br>
          </Row>
        </Form>
      </Modal>

    </>
  );
};

export default AddEditSfaMaster;
